import React, {useState} from "react";
import {useNavigate} from "react-router-dom";

import {DashboardCard} from "../../../../designSystem/components/DashboardCard";
import {Typography} from "../../../../designSystem/components/Typography";
import {ActionButton} from "../../../../designSystem/components/ActionButton";
import {Dialog} from "../../../../designSystem/components/Dialog";

import {ResetPasswordModalContent} from '../ResetPasswordModalContent'

import {MESSAGE_TYPE, useResetPassword} from "../../hooks/useResetPassword";
import {PasswordInput} from "../PasswordInput";

export const ResetPasswordFeature = () => {
  const [newPassword, setNewPassword] = useState<string>('');
  const navigate = useNavigate();

  const {
    message,
    messageType,
    dialogContent,
    submit,
    confirmCompleted
  } = useResetPassword({ newPassword })

  const onClickOkButton = () => {
    if (messageType === MESSAGE_TYPE.SUCCESS) {
      navigate('/login')
    } else {
      confirmCompleted();
    }
  }

  const canSubmit = newPassword?.length >= 8
  return (
    <React.Fragment>
      <div className="flex justify-center pt-20 px-5">
        <DashboardCard>
          <Typography variant="title">
            重設密碼
          </Typography>

          <PasswordInput
            value={newPassword}
            onChange={value => setNewPassword(value)}
          />

          <ActionButton
            fullWidth
            label="提交新密碼"
            disabled={!canSubmit}
            onClick={submit}
          />
        </DashboardCard>
      </div>

      <Dialog isOpen={dialogContent !== ''}>
        {ResetPasswordModalContent({
          message,
          messageType,
          onClickOkButton,
        })[dialogContent] || <></>}
      </Dialog>
    </React.Fragment>
  );
};

